import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import { Container, TimePlace } from './Common'

import TextButton from 'components/Luxkit/Button/TextButton'
import LineArrowRightIcon from 'components/Luxkit/Icons/line/LineArrowRightIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import { DAY_MONTH_NAME } from 'constants/dateFormats'
import { useRegionTimeFormat } from 'hooks/useRegionTimeFormat'
import TripItemSummary from 'tripPlanner/components/TripModal/TripItems/Summary'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import { ItemMetadata } from 'tripPlanner/models'
import { TransportItem } from 'tripPlanner/types/tripItem'
import { isLeBookmark, typeConstToTitle } from 'tripPlanner/utils'

const Content = styled.div`
  padding: ${rem(16)};
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};

  summary {
    display: flex;
    gap: ${rem(8)};
  }

  & > button:last-child {
    margin-top: ${rem(12)};
  }
`

interface Props {
  item: TransportItem
}

const TransportSummaryCard = React.forwardRef<HTMLDivElement, Props>(
  ({ item }: Props, ref) => {
    const {
      operatorName,
      startPlace,
      endPlace,
      type,
      startDate,
      startTime,
      endDate,
      endTime,
    } = item

    const openModal = useOpenModal()

    const onClick = () => openModal(TripItemSummary, { item })

    const timeFormat = useRegionTimeFormat()

    const IconComponent = ItemMetadata[item.type].icon
    return (
      <Container ref={ref}>
        <Content>
          <summary>
            <IconComponent size="XS" />
            <BodyText variant="small">
              {typeConstToTitle(type)}{' '}
              {operatorName && (
                <BodyText as="span" variant="small">
                  &bull; {operatorName}
                </BodyText>
              )}
            </BodyText>
          </summary>
          <TimePlace>
            <section>
              {startDate && (
                <BodyText variant="small">
                  {startDate.format(DAY_MONTH_NAME)}
                </BodyText>
              )}
              <Heading variant="heading6">{startPlace.name}</Heading>
              {startTime && (
                <BodyText variant="small">
                  {startTime.format(timeFormat)}
                </BodyText>
              )}
            </section>
            <section>
              <LineArrowRightIcon size="S" colour="neutral-four" />
            </section>
            {endPlace && (
              <section>
                {endDate && (
                  <BodyText variant="small">
                    {endDate.format(DAY_MONTH_NAME)}
                  </BodyText>
                )}
                <Heading variant="heading6">{endPlace.name}</Heading>
                {endTime && (
                  <BodyText variant="small">
                    {endTime.format(timeFormat)}
                  </BodyText>
                )}
              </section>
            )}
          </TimePlace>
          <TextButton kind="primary" onClick={onClick}>
            {isLeBookmark(item) ? 'View Offer' : 'View Details'}
          </TextButton>
        </Content>
      </Container>
    )
  },
)

export default TransportSummaryCard
